import type { RouteRecordRaw } from 'vue-router';

export const theoryRoute: RouteRecordRaw = {
  path: '/declensions/theory',
  name: 'DeclensionsTheory',
  component: () => import('./pages/DeclensionsTheoryPage.vue'),
  meta: { layout: 'main' },
};

export const tableRoute: RouteRecordRaw = {
  path: '/declensions/table',
  name: 'DeclensionsTable',
  component: () => import('./pages/DeclensionsTablePage.vue'),
  meta: { layout: 'main' },
};

export const trainerRoute: RouteRecordRaw = {
  path: '/declensions/trainer',
  name: 'DeclensionsTrainer',
  component: () => import('./pages/DeclensionsTrainerPage.vue'),
  meta: { layout: 'main' },
};
